export default __webpack_public_path__ + "static/media/visa-logo.d72c49e3.png";